export enum CashierPath {
  CallbackMitId = '/callback/mitid',
  CallbackPayment = '/callback/payment',
  CallbackRedirect = '/callback/redirect',
  Cashier = '/cashier',
  Deposit = '/deposit',
  DepositResult = '/deposit/result',
  ManageCurrencies = '/manage-currencies',
  P2pTransfer = '/p2p-transfer',
  PaymentMethods = '/payment-methods',
  RealMoneyForm = '/real-money-form',
  Signup = '/signup',
  TransactionHistory = '/transaction-history',
  Withdraw = '/withdraw'
}

export const cashierAliases = {
  firstWalletHome: CashierPath.Cashier
};
